import React from 'react';
import {
	captureException,
} from '@sentry/browser';

import {
	MELTINGSPOT_SPOT_ID
} from '~/config';

import ScreenLayout from '../patterns/screens/basicScreen/layouts/ScreenLayout';

import useExternalScript from '~/hooks/useExternalScript';
import useMeltingspotToken from '~/hooks/useMeltingspotToken';
import usePendoContext from '~/hooks/usePendoContext';



function onMeltingSpotLoaded(token: string | null) {
	document.getElementById('meltingspot-frame')?.replaceChildren()

	if (token) {
		// @ts-expect-error MeltingSpot is untyped
		window.MeltingSpot?.injectSpotInto(
			'meltingspot-frame',
			{
				spotId: MELTINGSPOT_SPOT_ID,
				themeMode: 'light',
				authToken: token,
			}
		);
	}
}



const CommunityScreen: React.FC = () => {
	const { token, loading, error } = useMeltingspotToken();
	const [scriptLoaded, setScriptLoaded] = React.useState(false);
	const pendo = usePendoContext();

	useExternalScript('https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js', () => {
		setScriptLoaded(true);
	});

	React.useEffect(() => {
		if (scriptLoaded && token) {
			onMeltingSpotLoaded(token);
		}
	}, [scriptLoaded, token]);

	// Track Community tab navigation in Pendo
	React.useEffect(() => {
		pendo.trackEvent('Community tab accessed', {})
			.catch((error) => {
				// Silently handle tracking errors (e.g., Pendo disabled, timeout)
				// Tracking failures should not break the UI
				captureException(error);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []); // Empty array ensures tracking only happens on mount, not on re-renders

	if (loading) {
		return (
			<ScreenLayout>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: 'calc(100vh - 4px)'
					}}
				>
					<div>Loading community...</div>
				</div>
			</ScreenLayout>
		);
	}

	if (error) {
		return (
			<ScreenLayout>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: 'calc(100vh - 4px)',
						flexDirection: 'column',
						gap: '16px'
					}}
				>
					<div>Unable to load Community</div>
					<div style={{ color: '#666', fontSize: '14px' }}>{error}</div>
				</div>
			</ScreenLayout>
		);
	}

	return (
		<ScreenLayout>
			<div
				id="meltingspot-frame"
				style={{ width: '100%', height: 'calc(100vh - 4px)' }}
			>
			</div>
		</ScreenLayout>
	);
};



export default CommunityScreen;
